<template>
  <form @submit.prevent class="needs-validated" novalidate autocomplete="off">
    <div class="card-body">
      <div class="label-text">
        <span>Edit Impacted Acres &amp; Development Rights</span>
      </div>
      <hr>
      <div class="form-group row">
        <label class="col-lg-4 label-text">
          Project ID
        </label>
        <div class="col-lg-8">
          {{property.projectId}}
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 label-text">
          Property ID
        </label>
        <div class="col-lg-8">
          {{property.id}}
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 label-text">
          Property Status
        </label>
        <div class="col-lg-8">
          {{getPropertyStatusName(property.statusId)}}
        </div>
      </div>
      <hr>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label label-text">
          <span class="text-danger">*</span>Impacted Property Acres
        </label>
        <div class="col-lg-6">
          <input
            :disabled="isPropertyAcresDisabled"
            class="form-control"
            v-model="propertyInstrument.propertyAcres"
            v-validate="isPropertyAcresDisabled ? '' : 'required|max_decimal:4'"
            name="propertyAcres"
            data-vv-as="Impacted Property Acres"
          />
          <small v-if="!errors.first('impactedPropertyAcres')" class="form-text text-muted">
            Max 4 decimal places
          </small>
          <div class="invalid-feedback">{{errors.first('propertyAcres')}}</div>
        </div>
        <div class="col-lg-2">
          <b-form-checkbox
            id="checkbox-1"
            v-model="isPropertyAcresDisabled"
            name="checkbox-1"
            @input="disablePropertyInstrumentField(isPropertyAcresDisabled, 'propertyAcres')"
            class="col-md-5 mb-2">
                N/A
            </b-form-checkbox>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label label-text">
          <span class="text-danger">*</span>Properties Allowed
        </label>
        <div class="col-lg-6">
          <input
            :disabled="isFuturePropertiesAllowedDisabled"
            class="form-control"
            v-model="propertyInstrument.futurePropertiesAllowed"
            v-validate="isFuturePropertiesAllowedDisabled ? '' : 'required|whole_number'"
            name="futurePropertiesAllowed"
            data-vv-as="Properties Allowed"
          />
          <div class="invalid-feedback">{{errors.first('futurePropertiesAllowed')}}</div>
        </div>
        <div class="col-lg-2">
          <b-form-checkbox
            id="checkbox-future-properties"
            v-model="isFuturePropertiesAllowedDisabled"
            name="checkbox-future-properties"
            @input="disablePropertyInstrumentField(isFuturePropertiesAllowedDisabled, 'futurePropertiesAllowed')"
              class="col-md-5 noselect mb-2">
                N/A
          </b-form-checkbox>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label label-text">
          <span class="text-danger">*</span>Dwellings Allowed
        </label>
        <div class="col-lg-6">
          <input
            :disabled="isDwellingsAllowedDisabled"
            class="form-control"
            v-model="propertyInstrument.dwellingsAllowed"
            v-validate="isDwellingsAllowedDisabled ? '' :'required|whole_number'"
            name="dwellingsAllowed"
            data-vv-as="Dwellings Allowed"
          />
          <div class="invalid-feedback">{{errors.first('dwellingsAllowed')}}</div>
        </div>
        <div class="col-lg-2">
          <b-form-checkbox
            id="checkbox-dwellings"
            v-model="isDwellingsAllowedDisabled"
            name="checkbox-dwellings"
            @input="disablePropertyInstrumentField(isDwellingsAllowedDisabled, 'dwellingsAllowed')"
              class="col-md-5 noselect mb-2">
                N/A
          </b-form-checkbox>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label label-text">
          <span class="text-danger">*</span>Finished Area Allowed (sq ft)
        </label>
        <div class="col-lg-6">
          <input
            :disabled="isFinishedAreaAllowedDisabled"
            class="form-control"
            v-model="propertyInstrument.finishedAreaAllowed"
            v-validate="isFinishedAreaAllowedDisabled ? '' : 'required|whole_number'"
            name="finishedAreaAllowed"
            data-vv-as="Finished Area Allowed"
          />
          <div class="invalid-feedback">{{errors.first('finishedAreaAllowed')}}</div>
        </div>
        <div class="col-lg-2">
          <b-form-checkbox
            id="checkbox-finished-area"
            v-model="isFinishedAreaAllowedDisabled"
            name="checkbox-finished-area"
            @input="disablePropertyInstrumentField(isFinishedAreaAllowedDisabled, 'finishedAreaAllowed')"
              class="col-md-5 noselect mb-2">
                N/A
          </b-form-checkbox>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label label-text">
          <span class="text-danger">*</span>Impervious Area Allowed (sq ft)
        </label>
        <div class="col-lg-6">
          <input
            :disabled="isImperviousAreaAllowedDisabled"
            class="form-control"
            v-model="propertyInstrument.imperviousAreaAllowed"
            v-validate="isImperviousAreaAllowedDisabled ? '' : 'required|whole_number'"
            name="imperviousAreaAllowed"
            data-vv-as="Impervious Area Allowed"
          />
          <div class="invalid-feedback">{{errors.first('imperviousAreaAllowed')}}</div>
        </div>
        <div class="col-lg-2">
          <b-form-checkbox
            id="checkbox-impervious-area"
            v-model="isImperviousAreaAllowedDisabled"
            name="checkbox-impervious-area"
            @input="disablePropertyInstrumentField(isImperviousAreaAllowedDisabled, 'imperviousAreaAllowed')"
              class="col-md-5 noselect mb-2">
                N/A
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <div class='card-footer right-align-content'>
      <b-button
        :disabled="submitting"
        variant="danger" class="button-row-spacing"
        v-b-modal="'cancelRightsConfirmation-' + property.id">
        Cancel
      </b-button>
      <b-button
        :disabled="submitting"
        @click="submitWrapper(property, propertyInstrument)">
        Save
      </b-button>
    </div>
    <CancelModal
      :modalId="'cancelRightsConfirmation-' + property.id"
      @cancelled="$emit('closeForm', property.id)">
    </CancelModal>
  </form>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import FormSubmit from '@/mixins/FormSubmit';
import CancelModal from '@/components/CancelModal.vue';

export default {
  name: 'EditAssociatedProperty',
  props: ['property', 'storeNamespace'],
  mixins: [FormSubmit],
  components: {
    CancelModal,
  },
  data() {
    const propInst = this.property.propertyInstruments[0];
    return {
      propertyInstrument: {
        id: propInst.id,
        propertyId: propInst.propertyId,
        instrumentId: propInst.instrumentId,
        propertyAcres: propInst.propertyAcres,
        futurePropertiesAllowed: propInst.futurePropertiesAllowed,
        dwellingsAllowed: propInst.dwellingsAllowed,
        finishedAreaAllowed: propInst.finishedAreaAllowed,
        imperviousAreaAllowed: propInst.imperviousAreaAllowed,
      },
      isPropertyAcresDisabled: propInst.propertyAcres === null || propInst.propertyAcres === '',
      isFuturePropertiesAllowedDisabled: propInst.futurePropertiesAllowed === null || propInst.futurePropertiesAllowed === '',
      isDwellingsAllowedDisabled: propInst.dwellingsAllowed === null || propInst.dwellingsAllowed === '',
      isFinishedAreaAllowedDisabled: propInst.finishedAreaAllowed === null || propInst.finishedAreaAllowed === '',
      isImperviousAreaAllowedDisabled: propInst.imperviousAreaAllowed === null || propInst.imperviousAreaAllowed === '',
    };
  },
  computed: {
    submitting() {
      return this.$store.state[this.storeNamespace].submitting;
    },
    ...mapGetters(LookupModules.PROPERTY_STATUSES.namespace, {
      getPropertyStatusName: 'getName',
    }),
    ...mapState(LookupModules.PROPERTY_STATUSES.namespace, {
      propertyStatusLoading: state => state.loading,
    }),
  },
  methods: {
    submitWrapper(property, propertyInstrument) {
      const submittedProperty = {};
      Object.assign(submittedProperty, property);
      submittedProperty.propertyInstruments = [propertyInstrument];
      submittedProperty.isAssociatedPropertyUpdate = true;
      this.onSubmitToStore(
        submittedProperty,
        this.storeNamespace,
        'propertyinstrument',
        null,
        () => this.$store.dispatch('Property/fetchPropertiesFromServer'),
      );
    },
    disablePropertyInstrumentField(isDisabled, fieldToUpdate) {
      if (isDisabled) {
        this.propertyInstrument[fieldToUpdate] = null;
      } else {
        this.propertyInstrument[fieldToUpdate] = 0;
      }
    },

  },
};
</script>
